import Icon from '@/legacy-src/components/icons/Icon'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { ButtonTag, type ButtonTagProps } from '@/src/domains/design-system/components/Tag'

export interface TherapistFilterActiveProps {
  children: string
  onClick: () => void
  variant?: ButtonTagProps['variant']
  size?: ButtonTagProps['size']
}

export const TherapistFilterActive = ({
  children,
  onClick,
  variant = 'blue',
  size = 's',
}: TherapistFilterActiveProps) => {
  const { t } = getTranslate()

  return (
    <ButtonTag
      size={size}
      variant={variant}
      className="flex items-center gap-1"
      onClick={onClick}
      aria-label={t('components.therapist.filter.action.remove', { name: children })}
    >
      {children}
      <Icon icon="cross" size={16} color="primary" />
    </ButtonTag>
  )
}
